import { Fragment } from "react";
import "./HomeCMSNoticeSkeleton.css";

/**
 * HomeCMSNoticeSkeleton component
 *
 * A simple skeleton placeholder component displayed while CMS notice data is loading.
 * It helps indicate loading state and improves perceived performance for the user.
 *
 * Styling:
 * - Applies skeleton styles via `home-cms-notice-skeleton` and `skeleton-placeholder` CSS classes.
 * - Styles are imported from `./HomeCMSNoticeSkeleton.css`.
 *
 * @component
 * @returns {JSX.Element} The skeleton UI for CMS notice content
 */
const HomeCMSNoticeSkeleton = () => {
    return (
        <Fragment>
            <div className="home-cms-notice-skeleton skeleton-placeholder"></div>
        </Fragment>
    );
}

export default HomeCMSNoticeSkeleton;
